import { getEnabledAuthProviders } from './getEnabledAuthProviders';

export function useEnabledAuthProviders() {
  return getEnabledAuthProviders(location?.hostname);
}
